import { fg } from '@confluence/feature-gating';

import type { GraphQLContentStatus } from '../__types__/ActiveCommentsQuery';
import { CommentType as CommentsType } from '../__types__/ActiveCommentsQuery';

export const ACTIVE_COMMENTS_QUERY_PRELOAD_COUNT = 3;
export const ACTIVE_COMMENTS_QUERY_EMPTY_PRELOAD_COUNT = 0;
export const ACTIVE_COMMENTS_QUERY_PRELOAD_LOADING_FLAG = -1; // We can't do cache.evict based on apollo version, so use -1 as a flag

export const ACTIVE_COMMENTS_QUERY_MAX_COUNT = 2000;
export const ACTIVE_COMMENTS_QUERY_1K_BATCH_SIZE = 1000;
export const ACTIVE_COMMENTS_QUERY_DEFAULT_LOAD_COUNT = 250;

export const buildConsistentActiveCommentsQueryPreloadVariables = (
	contentId: string,
	isArchived?: boolean,
) => {
	return {
		pageId: contentId,
		contentStatus: [isArchived ? 'ARCHIVED' : 'CURRENT', 'DRAFT'] as GraphQLContentStatus[],
		type: [CommentsType.FOOTER],
		first: fg('confluence_frontend_always_ssr_footer_comments')
			? ACTIVE_COMMENTS_QUERY_PRELOAD_COUNT
			: ACTIVE_COMMENTS_QUERY_EMPTY_PRELOAD_COUNT, // When SSRing all use preload count, when only SSRing empty use 0
	};
};

export const buildConsistentActiveCommentsQueryVariables = ({
	pageId,
	type,
	isArchived = false,
}: {
	pageId: string;
	type?: CommentsType | null;
	isArchived?: boolean;
}) => {
	let firstCount = ACTIVE_COMMENTS_QUERY_DEFAULT_LOAD_COUNT;

	if (fg('confluence_frontend_comments_1k_batch_size')) {
		firstCount = ACTIVE_COMMENTS_QUERY_1K_BATCH_SIZE;
	}

	// This feature gate should override the one above
	if (fg('confluence_frontend_always_ssr_footer_comments')) {
		firstCount = ACTIVE_COMMENTS_QUERY_MAX_COUNT;
	}

	return {
		pageId,
		contentStatus: [isArchived ? 'ARCHIVED' : 'CURRENT', 'DRAFT'] as GraphQLContentStatus[],
		first: firstCount,
		// eslint-disable-next-line confluence-feature-gating/no-preconditioning
		...(fg('confluence_frontend_content_wrapper') && type && { type: [type] }),
	};
};
